import Vue from 'vue'
import App from './App.vue'
import store from './store'
//导入路由 vue-router
import router from "./router/index";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 导入公共样式
import "./style/index.less"
// 导入字体图标
import "./assets/font/iconfont.css"
Vue.config.productionTip = false
import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle)
Vue.use(ElementUI)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

import ('./lib/css/base.css')